(() => {
  const params = new URLSearchParams(window.location.search);
  const variantId = params.get("add_to_cart");
  const qty = parseInt(params.get("qty") || "1", 10);
  const shouldOpen = params.get("open_cart_drawer") === "1";

  if (!variantId) return;

  // 1) Add to cart via AJAX (same-origin)
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
    },
    body: JSON.stringify({
      items: [{ id: Number(variantId), quantity: qty }],
    }),
  })
    .then(async (res) => {
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt);
      }
      return res.json();
    })
    .then(() => {
      // 2) Open drawer
      if (shouldOpen) {
        // a) Trigger the theme’s cart-added event (Horizon listens to this)
        document.dispatchEvent(new CustomEvent("CartAddEvent"));

        // b) Fallback: click the cart drawer trigger button
        const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
        if (trigger) trigger.click();
      }
    })
    .finally(() => {
      // 3) Clean URL so refresh doesn’t re-add
      params.delete("add_to_cart");
      params.delete("qty");
      params.delete("open_cart_drawer");
      const newQuery = params.toString();
      const newUrl =
        window.location.pathname +
        (newQuery ? `?${newQuery}` : "") +
        window.location.hash;
      window.history.replaceState({}, "", newUrl);
    });
})();